import { render } from "./ArchiveTermText.vue?vue&type=template&id=6fce9f7c"
import script from "./ArchiveTermText.vue?vue&type=script&lang=js"
export * from "./ArchiveTermText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__